export default "__VITE_ASSET__CdytxphC__"